import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from './locales/es.json'
import en from './locales/en.json'
import qu from './locales/qu.json'

const savedLang = localStorage.getItem('app_language') || 'es'

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    qu: { translation: qu },
  },
  lng: savedLang,
  fallbackLng: 'es',
  // Default nsSeparator is `:`, which collides with the menu key convention
  // (`menu.identity:directory:miners`) — i18next would parse the first `:`
  // as a namespace boundary and miss the lookup. Disabling it keeps `:` as
  // a literal character in keys; keySeparator (`.`) still splits namespaces.
  nsSeparator: false,
  interpolation: { escapeValue: false },
})

export default i18n
export { T } from './T'
export { useT } from './useT'
